// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"641":"08dbe0f031a2b3f2","3209":"35fd44cb86d46059","5387":"fc361e7dc80c088f"}[chunkId] + ".css";
};